// extracted by mini-css-extract-plugin
export default {"link":"AdminRegistrationNotification__link___owP4Z"};